import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMissing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.83 15.8095C18.94 15.5615 19 15.2895 19 15.0085V6.9905C18.9994 6.64157 18.9066 6.299 18.731 5.99748C18.5554 5.69596 18.3032 5.4462 18 5.2735L11 1.2655C10.6954 1.09151 10.3508 1 10 1C9.64925 1 9.30456 1.09151 9 1.2655L5.988 2.9905M3.441 4.4485L2 5.2735C1.381 5.6285 1 6.2835 1 6.9915V15.0095C1 15.7185 1.381 16.3725 2 16.7265L9 20.7345C9.30456 20.9085 9.64925 21 10 21M10 21C10.3508 21 10.6954 20.9085 11 20.7345L16.544 17.5605M10 21V11.0005L1.26953 5.96045M12.5322 9.53845L18.7302 5.96045M1 2.00049L19 20.0005",
		stroke: "#E2B216",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMissing;
